module.exports = __webpack_public_path__ + "static/media/web-cover1.a47417bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/web-cover1.jpg
// module id = 678
// module chunks = 0